module.exports = __webpack_public_path__ + "static/media/rci_oceanview_bedroom-790x592.a138e993.jpg";